// @ts-expect-error not migrated TS yet
import { selectFolderState } from 'email-management-lib/refactor/selectors/manage/foldersTable';
// @ts-expect-error not migrated TS yet
import { growl } from 'EmailComponents/errors/growl';
// @ts-expect-error not migrated TS yet

import ContentRoutes from 'ContentUtils/Routes';
import { trackDashboardInteraction, trackFrameworkTableInteraction } from 'EmailComponents/utils/tracking';
import { navigateTo } from 'EmailComponents/utils/urlUtils';
import { cancelEmail, edit } from 'EmailData/actions/emailActions';
import { assignPartitions, assignPartitionsAll, forceCancel } from 'EmailData/api/emailActions';
import * as EmailsAPI from 'EmailData/api/emails';
import { deleteEmail } from 'EmailData/api/emails';
import { getEmailPreviewUrl } from 'EmailData/utils/getEmailPreviewUrl';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import EmailModel from 'email-management-lib/Shared/models/EmailModel';
import { ASSIGN_USERS_TEAMS_EMAILS, CANCEL_EMAIL, CLOSE_PREVIEW, DELETE_EMAIL, EMAIL_UPDATE, EMAIL_UPDATE_REQUEST, MULTI_ARCHIVE, MULTI_ARCHIVE_CANCEL, MULTI_DELETE, MULTI_MOVE_TO_FOLDER, MULTI_UNARCHIVE, RECEIVE_HAS_ARCHIVED, REQUEST_ASSIGN_USERS_TEAMS_EMAILS, REQUEST_CANCEL_EMAIL, REQUEST_DELETE_EMAIL, SELECT_EMAIL_CRM_OBJECT, SELECT_USERS_TEAMS_EMAILS, UNSELECT_EMAILS, VIEW_EMAIL, VIEW_EMAIL_PERFORMANCE } from 'email-management-lib/refactor/actions/actionTypes';
import { fetchEmails, fetchFolders } from 'email-management-lib/refactor/actions/manage/general';
import { fetchEmailCrmObjectRequest, updateEmailDetails } from 'email-management-lib/refactor/api/emails';
import { getSelectedEmail } from 'email-management-lib/refactor/selectors/manage/table';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Link } from 'foundations-components/transitional/components/Link';
import allSettled from 'hs-promise-utils/allSettled';
import { Seq } from 'immutable';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
function multiAction({
  selectedEmailIds,
  action,
  actionType,
  dispatch,
  getState,
  isFramework = false,
  actionParam
}) {
  const promises = selectedEmailIds.map(id => {
    return EmailsAPI[action](id, actionParam);
  }).toArray();
  return allSettled(promises).then(resultPromises => {
    const numErrors = resultPromises.filter(promise => promise.status === 'rejected').length;
    if (numErrors > 0) {
      dispatch({
        type: actionType,
        error: true
      });
    }
    if (isFramework) {
      trackFrameworkTableInteraction({
        otherActions: `${action}-multiple`
      });
    } else {
      trackDashboardInteraction({
        otherActions: `${action}-multiple`
      });
    }
    dispatch({
      type: actionType,
      payload: {
        selectedEmailIds,
        actionParam
      }
    });
    if (!isFramework) {
      dispatch(fetchEmails());
    }
    dispatch({
      type: UNSELECT_EMAILS
    });
    if (selectFolderState(getState()).hasEverLoaded()) {
      dispatch(fetchFolders());
    }
  });
}
export function viewPerformance(emailId) {
  return dispatch => {
    dispatch({
      type: VIEW_EMAIL_PERFORMANCE
    });
    navigateTo(ContentRoutes.details(emailId, 2));
  };
}
export function selectUsersAndTeams(emailIds) {
  return dispatch => {
    dispatch({
      type: SELECT_USERS_TEAMS_EMAILS,
      payload: {
        emailIds
      }
    });
  };
}
export function viewEmail({
  emailId,
  previewKey,
  fromBuffer = true
}) {
  return dispatch => {
    dispatch({
      type: VIEW_EMAIL
    });
    const url = getEmailPreviewUrl(emailId, previewKey, fromBuffer);
    window.open(url);
  };
}
export function confirmDelete(emailId) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: REQUEST_DELETE_EMAIL
    });
    if (getSelectedEmail(state) === emailId) {
      dispatch({
        type: CLOSE_PREVIEW
      });
    }
    return deleteEmail(emailId).then(() => {
      dispatch({
        type: DELETE_EMAIL
      });
    }).catch(() => {
      dispatch({
        type: DELETE_EMAIL,
        error: true,
        payload: new Error(`Error deleting email ${emailId}`)
      });
    });
  };
}
export function multiMoveToFolder({
  selectedEmailIds,
  targetFolderId,
  selectedEmailNames,
  targetFolderName,
  isFramework
}) {
  return (dispatch, getState) => {
    return multiAction({
      selectedEmailIds,
      action: 'moveToFolder',
      actionType: MULTI_MOVE_TO_FOLDER,
      dispatch,
      getState,
      actionParam: targetFolderId,
      isFramework
    }).then(() => {
      if (!isFramework) {
        trackDashboardInteraction({
          otherActions: selectedEmailIds.size > 1 ? 'move-to-folder-multiple' : 'move-to-folder'
        });
      } else {
        trackFrameworkTableInteraction({
          otherActions: selectedEmailIds.size > 1 ? 'move-to-folder-multiple' : 'move-to-folder'
        });
      }
      let processedSelectedEmailNames = selectedEmailNames.slice(0, 3).join(', ');
      if (selectedEmailNames.length > 3) {
        processedSelectedEmailNames += '...';
      }
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link
          },
          message: `email-management.actions.${targetFolderName ? 'moveToFolderSuccess_jsx' : 'moveToHomeFolderSuccess_jsx'}`,
          options: {
            processedSelectedEmailNames,
            targetFolderName,
            href: ContentRoutes.emailFolder(String(targetFolderId))
          }
        }),
        type: 'success'
      });
    });
  };
}
export function assignUsersAndTeams(emailIds, data, options = {
  successKey: 'success',
  fetchEmails: true
}) {
  return dispatch => {
    dispatch({
      type: REQUEST_ASSIGN_USERS_TEAMS_EMAILS
    });
    trackDashboardInteraction({
      otherActions: `assignTeams`
    });
    return assignPartitions(emailIds.toArray(), data).then(() => {
      dispatch({
        type: ASSIGN_USERS_TEAMS_EMAILS
      });
      growl('info', I18n.text(`email-management.assignTeams.${options.successKey || 'success'}`, {
        count: emailIds.size
      }));
      if (options.fetchEmails) {
        return dispatch(fetchEmails());
      }
      return Promise.resolve();
    }).catch(() => {
      dispatch({
        type: ASSIGN_USERS_TEAMS_EMAILS,
        error: true,
        payload: new Error(`Error assigning users & teams to email ${emailIds.toArray()}`)
      });
      growl('error', I18n.text('email-management.assignTeams.error', {
        count: emailIds.size
      }));
    });
  };
}
export function bulkAssignUsersAndTeams(data, count, options = {
  fetchEmails: true
}) {
  return dispatch => {
    dispatch({
      type: REQUEST_ASSIGN_USERS_TEAMS_EMAILS
    });
    trackDashboardInteraction({
      otherActions: `assignTeamsUsingBulk`
    });
    return assignPartitionsAll(data).then(() => {
      dispatch({
        type: ASSIGN_USERS_TEAMS_EMAILS
      });
      growl('info', I18n.text(`email-management.assignTeams.bulkSuccess.message`), I18n.text(`email-management.assignTeams.bulkSuccess.title`, {
        count
      }));
      if (options.fetchEmails) {
        void dispatch(fetchEmails());
      }
    }).catch(() => {
      dispatch({
        type: ASSIGN_USERS_TEAMS_EMAILS,
        error: true,
        payload: new Error(`Error assigning users & teams`)
      });
      growl('error', I18n.text(`email-management.assignTeams.error.other`), ASSIGN_USERS_TEAMS_EMAILS);
    });
  };
}
export function multiArchive(selectedEmailIds, isFramework = false) {
  return (dispatch, getState) => {
    return multiAction({
      selectedEmailIds,
      action: 'archive',
      actionType: MULTI_ARCHIVE,
      dispatch,
      getState,
      isFramework
    }).then(() => {
      dispatch({
        type: RECEIVE_HAS_ARCHIVED,
        payload: true
      });
    });
  };
}

// can include non automated emails
export function multiArchiveAndCancel(selectedEmailIds, isFramework = false) {
  return (dispatch, getState) => {
    const isPublishedAutomated = emailId => {
      const state = getState();
      const emailInfo = isFramework ? EmailModel.from(state.getIn(['manage', 'frameworkTable']).selectedMultiEmailCrmObjects.find(crmObject => crmObject.properties[PROPERTIES.MARKETING_EMAIL_ID].value === emailId.toString())) : state.getIn(['manage', 'table', 'selectedEmailRows', emailId]);
      return emailInfo.isPublishedAutomated();
    };
    const automatedEmailIds = selectedEmailIds.filter(emailId => isPublishedAutomated(emailId));
    const nonAutomatedEmailIds = selectedEmailIds.filterNot(emailId => isPublishedAutomated(emailId));
    const archiveAndCancelPromise = multiAction({
      selectedEmailIds: Seq(automatedEmailIds),
      action: 'archiveAndCancel',
      actionType: MULTI_ARCHIVE_CANCEL,
      dispatch,
      getState,
      isFramework
    });
    const archivePromise = multiAction({
      selectedEmailIds: Seq(nonAutomatedEmailIds),
      action: 'archive',
      actionType: MULTI_ARCHIVE,
      dispatch,
      getState,
      isFramework
    });
    return Promise.all([archiveAndCancelPromise, archivePromise]).then(() => {
      dispatch({
        type: RECEIVE_HAS_ARCHIVED,
        payload: true
      });
    });
  };
}
export function multiDelete(selectedEmailIds, isFramework = false) {
  return (dispatch, getState) => {
    const panelEmailId = getSelectedEmail(getState());
    if (panelEmailId > 0 && selectedEmailIds.has(panelEmailId)) {
      dispatch({
        type: CLOSE_PREVIEW
      });
    }
    return multiAction({
      selectedEmailIds,
      action: 'deleteEmail',
      actionType: MULTI_DELETE,
      dispatch,
      getState,
      isFramework
    });
  };
}
export function multiUnarchive(selectedEmailIds, isFramework = false) {
  return (dispatch, getState) => {
    return multiAction({
      selectedEmailIds,
      action: 'unarchive',
      actionType: MULTI_UNARCHIVE,
      dispatch,
      getState,
      isFramework
    });
  };
}
export function editScheduled({
  emailId,
  email = null
}) {
  return dispatch => {
    dispatch(cancelEmail(emailId)).then(() => dispatch(edit({
      emailId,
      email
    }))).catch(e => Raven.captureException(e));
  };
}
export function cancelProcessing(emailId) {
  return dispatch => {
    dispatch({
      type: REQUEST_CANCEL_EMAIL
    });
    return forceCancel(emailId).then(() => {
      dispatch({
        type: CANCEL_EMAIL
      });
    }).catch(() => {
      dispatch({
        type: CANCEL_EMAIL,
        error: true,
        payload: new Error(`Error force canceling email ${emailId}`)
      });
    });
  };
}
export function editDashboard({
  emailId,
  email = null
}) {
  return dispatch => {
    trackDashboardInteraction({
      otherActions: 'edit'
    });
    dispatch(edit({
      emailId,
      email
    }));
  };
}
export function editEmailAutomation(emailId) {
  if (!emailId) {
    Raven.captureException(new Error('Error when trying to redirect to the automation tab, emailId is missing'));
  }
  return () => {
    navigateTo(ContentRoutes.editEmailAutomation(emailId));
  };
}
export function addAutomation() {
  return () => {
    navigateTo(ContentRoutes.workflowsDashboard());
  };
}
export function updateEmail(emailId, updatedFields, ignoreTimestamp = false) {
  return dispatch => {
    dispatch({
      type: EMAIL_UPDATE_REQUEST
    });
    updateEmailDetails(emailId, updatedFields, ignoreTimestamp).then(detailsContext => {
      dispatch({
        type: EMAIL_UPDATE,
        payload: detailsContext
      });
    }, err => {
      dispatch({
        type: EMAIL_UPDATE,
        error: true,
        payload: err
      });
      const userFriendlyError = I18n.text('email-management.errors.email.update');
      growl('error', userFriendlyError, EMAIL_UPDATE);
    }).catch(e => Raven.captureException(e));
  };
}
export function fetchEmailCrmObject(id) {
  return dispatch => {
    fetchEmailCrmObjectRequest(id).then(response => {
      dispatch({
        type: SELECT_EMAIL_CRM_OBJECT,
        payload: {
          crmObject: response.results[0]
        }
      });
    }).catch(e => Raven.captureException(e));
  };
}